import React from 'react';
import { useSelector } from 'react-redux';
import { savePaginationData } from '../../../redux/features/globalDatagridSlice';
import GlobalReject from '../../../components/mui/Dialogue/GlobalReject';
import { approveOrRejectProcurementHead, getSale } from '../../../redux/features/assetManagementSlice';

const ProcureHeadReject = ({ dispatchParams, loading, saleId, disable }) => {
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  return (
    <GlobalReject
      disabled={disable}
      title={'Approve'}
      displayNote={'Are you sure? you want to Reject this Request..?'}
      api={approveOrRejectProcurementHead({ saleId: saleId, status: 2 })}
      upDateCall={getSale(dispatchParams)}
      updatePaginationCall={savePaginationData({
        ...paginationData,
        openAnchor: false,
      })}
      loading={loading}
    />
  );
};

export default ProcureHeadReject;
